import {
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
    selector: 'app-snackbar',
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    standalone: false
})
export class SnackbarComponent implements OnChanges {

  @Input() message: string = "";
  @Input() isDark: boolean = false;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  show: boolean = false;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ( (changes.message && changes.message.currentValue)) {
      // Show the component only if input message has value
      this.show = true;
    }
  }
  hideSnackbar() {
    this.show = false;
    this.closed.emit(true);
  }

}
